import { AnimatePresence, motion } from 'motion/react';
import { useId, useState } from 'react';
import type { Feature, GetLabel } from '../types/feature';

interface KeyPointsProps {
	items: Feature['detail_func'];
	getLabel: GetLabel;
}

const VISIBLE_ITEMS = 4;

const renderItem = ([key, value]: [string, string]) => <li dangerouslySetInnerHTML={{ __html: value }} key={key} className={value ? 'check' : 'cross'}></li>;

export default function KeyPoints({ items, getLabel }: KeyPointsProps) {
	const [isExpanded, setIsExpanded] = useState(false);
	const moreId = useId();

	const entries = Object.entries(items);
	const visibleEntries = entries.slice(0, VISIBLE_ITEMS);
	const hiddenEntries = entries.slice(VISIBLE_ITEMS);

	return (
		<>
			<ul className="list list-item--key-points">{visibleEntries.map(renderItem)}</ul>

			{hiddenEntries.length > 0 && (
				<>
					<AnimatePresence initial={false}>
						{isExpanded && (
							<motion.ul
								id={moreId}
								className="list list-item--key-points list-item--key-points-more"
								initial={{ height: 0, opacity: 0 }}
								animate={{ height: 'auto', opacity: 1 }}
								exit={{ height: 0, opacity: 0 }}
								transition={{ duration: 0.3, ease: 'easeInOut' }}
							>
								{hiddenEntries.map(renderItem)}
							</motion.ul>
						)}
					</AnimatePresence>

					<button
						type="button"
						className="list-item--key-points-toggle"
						aria-expanded={isExpanded}
						aria-controls={moreId}
						onClick={() => setIsExpanded(!isExpanded)}
					>
						{isExpanded ? getLabel('show_less') : getLabel('show_more').replace('%d', String(hiddenEntries.length))}
						<span className="list-item--key-points-toggle-icon" aria-hidden="true">
							keyboard_arrow_down
						</span>
					</button>
				</>
			)}
		</>
	);
}
